import React, { FC, PropsWithChildren } from 'react'

import { Box } from '@mui/material'
import { HBox, SquareButton } from '../../elements/basic-elements'
import LogoLink from '../logo-link'
import CloseIcon from '../../images/icons/close-icon'
import { navigate } from 'gatsby'

const HeaderCloseableFlow: FC<PropsWithChildren & { onClose: () => void }> = ({ children, onClose }) => {
  return (
    <Box p={{ xs: '10px', sm: 2 }}>
      <HBox justifyContent="space-between" gap={2} alignItems="flex-start">
        <HBox>
          <LogoLink logoOnlyBreakpoint="md" includeINILink />
        </HBox>
        {children}

        <SquareButton
          variant='contained'
          color="tertiary"
          disableElevation
          onClick={onClose ? onClose : () => navigate('/')}
        >
          <CloseIcon />
        </SquareButton>
      </HBox>
    </Box>
  )
}

export default HeaderCloseableFlow
